const mapShippingOptionFromApi = ({ ShipOptionId: id, ShipOptionName: name }) => ({ id, name })

const mapShippingOptionsFromApi = (shippingOptions) => {
  return { options: shippingOptions.map(mapShippingOptionFromApi) }
}

export default {
  mapShippingOptionsFromApi
}
